import { urlEndPoints } from "../../constants/constants.ts";
import { NavbarElementProps } from "../../constants/interface.ts";

export const navbarElements: NavbarElementProps[] = [
    {
        title: 'NAVBAR.PRODUCTS',
        list: [
            {
                img: "/assets/images/svg/user-sound-blue-icon.svg",
                title: 'NAVBAR.DIGITAL_VOICE_AND_IVR_SOLUTIONS',
                para: 'NAVBAR.DIGITAL_VOICE_AND_IVR_SOLUTIONS_DESC',
                list: [
                    {
                        title: 'NAVBAR.VOICE_SERVICES',
                        img: "/assets/images/png/nav-prod-img-3.webp",
                        list: [
                            {
                                title: 'NAVBAR.VOICE_MAIL',
                                para: 'NAVBAR.VOICE_MAIL_DESC',
                                link: `products/${urlEndPoints.product.VOICE_MAIL}`,
                                list: null
                            },
                            {
                                title: 'NAVBAR.VOICE_CHAT',
                                para: 'NAVBAR.VOICE_CHAT_DESC',
                                link: `products/${urlEndPoints.product.VCS}`,
                                list: null
                            },
                            {
                                title: 'NAVBAR.VOICE_SMS',
                                para: 'NAVBAR.VOICE_SMS_DESC',
                                link: `products/${urlEndPoints.product.VOICE_SMS}`,
                                list: null
                            },
                        ]
                    },
                    {
                        title: 'NAVBAR.INTERACTIVE_VOICE_RESPONSE_IVR_SOLUTIONS',
                        img: "/assets/images/png/nav-prod-img-3.webp",
                        list: [
                            {
                                title: 'NAVBAR.IVR_PODCAST',
                                para: 'NAVBAR.IVR_PODCAST_DESC',
                                link: `products/${urlEndPoints.product.IVR_PODCAST}`,
                                list: null
                            },
                            {
                                title: 'NAVBAR.IVR_LANGUAGE_SUPPORT',
                                para: 'NAVBAR.IVR_LANGUAGE_SUPPORT_DESC',
                                link: `products/${urlEndPoints.product.IVR_LS}`,
                                list: null
                            },
                            {
                                title: 'NAVBAR.IVR_M_WOMAN',
                                para: 'NAVBAR.IVR_M_WOMAN_DESC',
                                link: `products/${urlEndPoints.product.IVR_M_WOMAN}`,
                                list: null
                            },
                            {
                                title: 'NAVBAR.IVR_QUIZ',
                                para: 'NAVBAR.IVR_QUIZ_DESC',
                                link: `products/${urlEndPoints.product.IVR_QUIZ}`,
                                list: null
                            },
                            {
                                title: 'NAVBAR.IVR_SPORTS',
                                para: 'NAVBAR.IVR_SPORTS_DESC',
                                link: `products/${urlEndPoints.product.IVR_SPORT}`,
                                list: null
                            },
                            {
                                title: 'NAVBAR.IVR_HEALTH',
                                para: 'NAVBAR.IVR_HEALTH_DESC',
                                link: `products/${urlEndPoints.product.IVR_M_HEALTH}`,
                                list: null
                            },
                            {
                                title: 'NAVBAR.IVR_M_FARM',
                                para: 'NAVBAR.IVR_M_FARM_DESC',
                                link: `products/${urlEndPoints.product.IVR_M_FARM}`,
                                list: null
                            },
                        ]
                    },
                    /*
                    {
                        title: 'HOME_PAGE.VOICE_SMS',
                        img: "/assets/images/png/nav-prod-img-3.webp",
                        list: [
                            {
                                title: 'NAVBAR.INTERACTIVE_MESSAGING',
                                // link: 'products/interactive-messaging-personalized-communication',
                                link: 'no-data',
                                list: null
                            }
                        ]
                    }
                    */
                ],
            },
            {
                img: "/assets/images/svg/signal-blue-icon.svg",
                title: 'NAVBAR.TC_AND_VAS_SERVICES',
                para: 'NAVBAR.TC_AND_VAS_SERVICES_DESC',
                list: [
                    {
                        title: 'NAVBAR.NETWORK_VAS_MANAGEMENT',
                        img: "/assets/images/png/nav-prod-img-4.webp",
                        list: [
                            {
                                title: "NAVBAR.SDF",
                                para: 'NAVBAR.SDF_DESC',
                                link: `products/${urlEndPoints.product.SDF}`,
                                list: null
                            },
                            {
                                title: "NAVBAR.CRBT",
                                para: 'NAVBAR.CRBT_DESC',
                                link: `products/${urlEndPoints.product.CRBT}`,
                                list: null
                            },
                            {
                                title: "NAVBAR.BALANCE_PLUS_PLUS",
                                para: 'NAVBAR.BALANCE_PLUS_PLUS_DESC',
                                link: `products/${urlEndPoints.product.BPP}`,
                                list: null
                            },
                            {
                                title: "NAVBAR.USSD_CHAT",
                                para: 'NAVBAR.USSD_CHAT_DESC',
                                link: `products/${urlEndPoints.product.USSD_CHAT}`,
                                list: null
                            },
                            {
                                title: "NAVBAR.UCP",
                                para: 'NAVBAR.UCP_DESC',
                                link: `products/${urlEndPoints.product.UCP_REPORTS}`,
                                list: null
                            },
                            {
                                title: "NAVBAR.CALL_COMPLETION_SERVICES",
                                para: 'NAVBAR.CALL_COMPLETION_SERVICES_DESC',
                                link: `products/${urlEndPoints.product.CCS}`,
                                list: null
                            },
                            /* // hidden, as per Asif sir's request.
                            {
                                title: "NAVBAR.SMS_MANAGER",
                                para: 'NAVBAR.SMS_MANAGER_DESC',
                                link: `products/${urlEndPoints.product.SMS_MANAGER}`,
                                list: null
                            },
                            */
                        ]
                    },
                    {
                        title: 'NAVBAR.CUSTOMER_ENGAGEMENT_TOOLS',
                        img: "/assets/images/png/nav-prod-img-4.webp",
                        list: [
                            {
                                title: "NAVBAR.SELF_CARE",
                                para: 'NAVBAR.SELF_CARE_DESC',
                                link: `products/${urlEndPoints.product.SCP}`,
                                list: null
                            },
                            {
                                title: "NAVBAR.CRM",
                                para: 'NAVBAR.CRM_DESC',
                                link: `products/${urlEndPoints.product.CRM}`,
                                list: null
                            },
                            {
                                title: "NAVBAR.CVM",
                                para: 'NAVBAR.CVM_DESC',
                                link: `products/${urlEndPoints.product.CVM}`,
                                list: null
                            },
                            {
                                title: "NAVBAR.GROUPY",
                                para: 'NAVBAR.GROUPY_DESC',
                                link: `products/${urlEndPoints.product.GROUPY}`,
                                list: null
                            },
                        ]
                    },
                    {
                        title: 'NAVBAR.SECURITY_UTILITY_SERVICES',
                        img: "/assets/images/png/nav-prod-img-4.webp",
                        list: [
                            {
                                title: "NAVBAR.ANTI_THEFT_SOLUTIONS",
                                para: 'NAVBAR.ANTI_THEFT_SOLUTIONS_DESC',
                                link: `products/${urlEndPoints.product.ATS}`,
                                list: null
                            },
                            // {
                            //     title: "NAVBAR.EMERGENCY_CREDIT_MANAGEMENT",
                            //     para: 'NAVBAR.EMERGENCY_CREDIT_MANAGEMENT_DESC',
                            //     link: `products/${urlEndPoints.product.ECM}`,
                            //     list: null
                            // },
                            {
                                title: 'NAVBAR.EMERGENCY_VOICE_CREDIT',
                                para: 'NAVBAR.EMERGENCY_VOICE_CREDIT_DESC',
                                link: `products/${urlEndPoints.product.EVC}`,
                                list: null
                            }
                        ]
                    },
                ]
            },
            {
                img: "/assets/images/svg/vss-blue-icon.svg",
                title: 'NAVBAR.INDUSTRY_SPECIFIC_M_VAS_SOLUTIONS',
                para: 'NAVBAR.INDUSTRY_SPECIFIC_M_VAS_SOLUTIONS_DESC',
                list: [
                    {
                        title: '',
                        img: "/assets/images/png/prod-m-farm-1.webp",
                        list: [
                            {
                                title: "NAVBAR.M_FARM",
                                para: 'NAVBAR.M_FARM_DESC',
                                link: `products/${urlEndPoints.product.M_FARM}`,
                                list: null
                            },
                            {
                                title: "NAVBAR.M_EDUCATION",
                                para: 'NAVBAR.M_EDUCATION_DESC',
                                link: `products/${urlEndPoints.product.M_EDUCATION}`,
                                list: null
                            },
                            {
                                title: "NAVBAR.M_WOMAN",
                                para: 'NAVBAR.M_WOMAN_DESC',
                                link: `products/${urlEndPoints.product.M_WOMAN}`,
                                list: null
                            },
                            {
                                title: "NAVBAR.M_SURVEY",
                                para: 'NAVBAR.M_SURVEY_DESC',
                                link: `products/${urlEndPoints.product.M_SURVEY}`,
                                list: null
                            },
                            {
                                title: "NAVBAR.M_SPORTS",
                                para: 'NAVBAR.M_SPORTS_DESC',
                                link: `products/${urlEndPoints.product.M_SPORTS}`,
                                list: null
                            },
                        ]
                    }
                ]
            },
            {
                img: "/assets/images/svg/heart-beat-blue-icon.svg",
                title: 'NAVBAR.HEALTHCARE',
                para: 'NAVBAR.THE_LATEST_HEALTHCARE',
                list: [
                    {
                        img: "/assets/images/png/nav-prod-img-1.webp",
                        title: 'HOME_PAGE.M_HEALTH',
                        list: [
                            {
                                title: 'NAVBAR.TELE_CONSULTATION_AND_VIRTUAL_CARE',
                                para: '',
                                link: `products/${urlEndPoints.product.M_HEALTH}`,
                                list: null
                            },
                        ]
                    },
                ],
            },
            {
                img: "/assets/images/svg/student-blue-icon.svg",
                title: 'NAVBAR.EDUCATION',
                para: 'NAVBAR.EDUCATORS_USE_INNOVII',
                list: [		
                    {
                        title: 'NAVBAR.UNIVERSITY_MANAGEMENT_SYSTEM',
                        img: "/assets/images/png/nav-prod-img-2.webp",
                        list: [
                            {
                                title: 'NAVBAR.ONE_PLATFORM_ADMIN_FACULTY_STUDENTS',
                                link: `products/${urlEndPoints.product.UMS}`,
                                list: null
                            },
                        ]
                    },
                    /* // content not available :
                    {
                        title: 'NAVBAR.M_LEARNING',
                        img: "/assets/images/png/nav-prod-img-2.webp",
                        list: [
                            {
                                title: 'NAVBAR.MOBLIE_LEARN_PLATFORMS',
                                link: `products/${urlEndPoints.product.M_LEARNING}`,
                                list: null
                            },
                        ]
                    }
                    */
                ],
            }
        ]
    },
    {
        title: 'NAVBAR.SERVICES',
        list: [
            {
                img: "/assets/images/svg/cpu-blue-icon.svg",
                title: 'NAVBAR.DIGITAL_TRANSFORMATION',
                link: `services/${urlEndPoints.Service.DIGITAL_TRANSFORMATION}`,
                list: null
            },
            {
                img: "/assets/images/svg/seal-percent-blue-icon.svg",
                title: 'NAVBAR.MARKETING_SALES_STRATEGY',
                link: `services/${urlEndPoints.Service.MARKETING_SALES_STRATEGY}`,
                list: null
            },
            {
                img: "/assets/images/svg/headset-blue-icon.svg",
                title: 'NAVBAR.CONSULTING_SERVICES',
                link: `services/${urlEndPoints.Service.CONSULTING_SERVICES}`,
                list: null
            },
        ]
    },
    {
        title: 'NAVBAR.COMPANY',
        list: [
            {
                img: "/assets/images/svg/buildings-blue-icon.svg",
                title: 'NAVBAR.ABOUT_US',
                link: urlEndPoints.Company.ABOUT_US,
                list: null
            },
            {
                img: "/assets/images/svg/users-blue-icon.svg",
                title: 'NAVBAR.CONTACT_US',
                link: urlEndPoints.Company.CONTACT_US,
                list: null
            },
            /* // hidden, as per Asif sir's request.
            {
                img: "/assets/images/svg/briefcase-blue-icon.svg",
                title: 'NAVBAR.CAREER',
                link: urlEndPoints.Company.CAREER,
                list: null
            },
            */
        ]
    },
];